module.exports = __webpack_public_path__ + "static/media/СЗФО_2006.0f8e6287.png";